import { AWARD_LEVELS } from 'constants/enums'

export default function(levelId) {
  if (levelId === AWARD_LEVELS.gold.id) {
    return 3
  } else if (levelId === AWARD_LEVELS.silver.id) {
    return 2
  }
  return 1
}
